import { useLocation } from "react-router-dom";

function EditBanner(props){
    const location=useLocation();
    const bannerType=location.state!=null?location.state.type:"";
     return (
        <>
          {/* {isLoading && <AppLodingBar />} */}
          <div
            style={{
              position: "fixed",
              backgroundColor: "rgba(0,0,0,0.5)",
              width: "100%",
              height: "100%",
              zIndex: "999",
              overflow: "scroll",
    
            }}
          >
            <div className="d-flex align-item-center justify-content-center">
              <div className="col-md-8">
                <div className="container">
                  <div className="row mt-5">
                    <div className="col-md-5 card-1 p-5">
    
                      <h4 className="text-center">Edit</h4>

                      {
                        bannerType=="home"?
                        <>
                          
                      </>
                      :""
                      }
    
                      <div className="col-md-12">
                        <div className="form-group">
    
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: 20,
                            }}
                          >
                            <button
                              style={{ display: "flex", justifyContent: "center" }}
                              type="button"
                              className="btn btn-purple-bg"
                              
                            >
                              Ok
                            </button>
                            <button
                              className="btn btn-white-bg"
                            //   onClick={() => dispatch(displayRemoveAlert({ displayRemove: false, formData: null }))}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
}

export default EditBanner